/* Defer non-critical init to after first paint (requestIdleCallback + fallback) */
function runWhenIdle(cb) {
    (window.requestIdleCallback || function (fn) { setTimeout(fn, 1); })(cb);
}

/* Mobile menu burger toggle.
   Opening paints immediately (.is-open, transition:none). Closing swaps
   .is-open for .is-closing so the panel keeps its open geometry and
   visibility for the length of the 120ms fade, then drops the class — on the
   panel's own transitionend, or on a 220ms timer if that event never fires
   (transitions disabled, throttled background tab, interrupted paint). The
   base rule is the terminal state: visibility:hidden + 64px container, so no
   path can leave the panel painted-but-inert or hidden-but-occupying the
   viewport. Re-opening mid-exit removes .is-closing first, so the panel
   returns from its current opacity instead of snapping. */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    const panel = navigation.querySelector('.gh-navigation-menu');
    let closeTimer = null;
    let closing = false;

    function prefersReducedMotion() {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function finishClose() {
        if (closeTimer) {
            window.clearTimeout(closeTimer);
            closeTimer = null;
        }
        closing = false;
        navigation.classList.remove('is-closing');
        document.documentElement.style.overflowY = null;
    }

    if (panel) {
        panel.addEventListener('transitionend', function (e) {
            // Only the panel's own opacity fade ends the close (children
            // bubble their own transitionend events).
            if (closing && e.target === panel && e.propertyName === 'opacity') {
                finishClose();
            }
        });
    }

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            finishClose();
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            if (prefersReducedMotion()) {
                // No closing class under reduce: .is-open removal lands the
                // terminal closed state in this same frame.
                finishClose();
                return;
            }
            closing = true;
            navigation.classList.add('is-closing');
            if (closeTimer) {
                window.clearTimeout(closeTimer);
            }
            closeTimer = window.setTimeout(finishClose, 220);
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content (deferred — below the fold) */
(function () {
    runWhenIdle(function () {
        const sources = [
            '.gh-content iframe[src*="youtube.com"]',
            '.gh-content iframe[src*="youtube-nocookie.com"]',
            '.gh-content iframe[src*="player.vimeo.com"]',
            '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
            '.gh-content object',
            '.gh-content embed',
        ];
        reframe(document.querySelectorAll(sources.join(',')));
    });
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items (deferred) */
(function () {
    runWhenIdle(function () {
        dropdown();
    });
})();

/* Infinite scroll pagination (deferred — below the fold) */
(function () {
    runWhenIdle(function () {
        if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
            pagination();
        }
    });
})();

/* Responsive HTML table (deferred — below the fold) */
(function () {
    runWhenIdle(function () {
        const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');

        tables.forEach(function (table) {
            const wrapper = document.createElement('div');
            wrapper.className = 'gh-table';
            table.parentNode.insertBefore(wrapper, table);
            wrapper.appendChild(table);
        });
    });
})();

/* ============================================================
   SCROLL-TRIGGERED REVEAL ANIMATIONS
   Uses IntersectionObserver for sections below the hero.
   ============================================================ */
(function () {
    // Only on homepage
    if (!document.body.classList.contains('home-template')) return;

    const revealEls = document.querySelectorAll('.reveal-on-scroll, .reveal-stagger');
    if (!revealEls.length) return;

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.12,
        rootMargin: '0px 0px -40px 0px'
    });

    revealEls.forEach(function (el) {
        observer.observe(el);
    });
})();

/* ============================================================
   NAVIGATION SCROLL STATE
   Adds a shadow/backdrop when scrolled past hero.
   ============================================================ */
(function () {
    if (!document.body.classList.contains('home-template')) return;

    const nav = document.querySelector('.gh-navigation');
    if (!nav) return;

    let ticking = false;

    function updateNav() {
        if (window.scrollY > 60) {
            nav.classList.add('is-scrolled');
        } else {
            nav.classList.remove('is-scrolled');
        }
        ticking = false;
    }

    window.addEventListener('scroll', function () {
        if (!ticking) {
            window.requestAnimationFrame(updateNav);
            ticking = true;
        }
    }, { passive: true });

    // Initial state
    updateNav();
})();
